import React, { useState, useRef, forwardRef, useImperativeHandle, useEffect } from "react";
import { Row, Col, Container, Button, Form } from "react-bootstrap";
import ConfirmAlertModal from "../Modals/confirmAlertModal";
import { useLocation, Link } from "react-router-dom";
import GolbalSearch from "../utility/common/helpers/GolbalSearch";
import { handleExport1 } from "../utility/data/export/GlobalExport";
import { getGridHeaderData } from "../../Services/wcs-services";
import GlobalColumnDefinations, { getHeader_FieldName } from "../utility/grid/definitions/AgGridDefination";
import GridMaster from "../utility/grid/GridMaster";
import Export_blue from "../../icons/Export_blue.svg";
import ExportIcon from "../../icons/ExportIcon.svg";
import BarLoader from "react-spinners/BarLoader";
import { isAlphanumericWithDash } from "../../functions/validations";
import { SearchSelect } from "../utility/forms/inputs/search-select";
import { Action, Status } from "./WCSObjects/WCS_entity";
import AddEditWCS from "./AddEditWCS";
import { getAllOnlyProject } from "../../Services/project-services";
import UploadWCSExcel from "./UploadWCSExcel";
import Toaster, { showError } from "../utility/ui/notifications/Toaster";
import { errorstyle, normalstyle } from "../../functions/welding-functions";

const HyperLink = (params) => {
  return (
    <Link
      to="/WCSdetail"
      state={{ data: params.data.SK }}
      className="add-new-link"
    >
      {params.data.SK}
    </Link>
  );
};

const WCSDashboard = forwardRef((props, ref) => {
  const location = useLocation();
  const [originalaction] = useState(location.state?.action);
  let Band = sessionStorage.getItem("Band");
  const [headerObj, setheaderObj] = useState([]);
  let initiator = Band !== "P" && Band !== "T";
  const [rowData, setRowData] = useState({});
  const [filteredResult, setFilteredResult] = useState([]);
  const [columnDefs, setColumnDefs] = useState([]);
  const [WCS, setWCS] = useState(null);
  const [showForm, setShowForm] = useState(false);
  const [action, setAction] = useState("");
  const [reload, setReload] = useState(false);
  const [, setExcelData] = useState([]);
  const [, setShowDetailForm] = useState(false);
  const [selectProject, setSelectProject] = useState(headerObj.WCS_Project_No);
  let disableButton = initiator && headerObj.WPSH_Status === Status.StatusPending ? true : false;
  const [isDisabled] = useState(disableButton);
  const [showUploadExcelForm, setshowUploadExcelForm] = useState(false);
  const [loading, setLoading] = useState(true);
  const [ProjectDetails, setProjectDetails] = useState([]);
  const [error, setError] = useState({
    WCS_Project_No: {},
  });

  const childRef = useRef();

  const tmpcolumnDefs = [
    {
      headerName: "Status",
      field: "WCS_Status",
      type: "Text",
      isCheckbox: false,
      cellRenderer: "WPSCellRenderer",
    },
    {
      headerName: "Project No.",
      field: "WCS_Project_No",
      cellRenderer: HyperLink,

    },
    {
      headerName: "WCS Change No.",
      field: "WCS_Change_No",
      type: "Text",
      isCheckbox: false,
      cellRenderer: "",
    },
    {
      headerName: "Prepared by",
      field: "WCS_PreparedBy_Name",
      type: "Text",
      isCheckbox: false,
      cellRenderer: "AvatarCellRenderer",
    },
    {
      headerName: "Approved by",
      field: "WCS_ApprovedBy_Name",
      type: "Text",
      isCheckbox: false,
      cellRenderer: "AvatarCellRenderer",
    },
  ];

  const handleView = (row) => {
    setAction("View");
    setRowData(row);
    setShowDetailForm(true);
  };

  const headerName = (field) => {
    let name = getHeader_FieldName(field, tmpcolumnDefs, "getHeader");
    return name;
  };

  const fieldName = (header) => {
    let name = getHeader_FieldName(header, tmpcolumnDefs, "getField");
    return name;
  };

  const fetchWCS = async () => {
    let result = await getGridHeaderData(
      sessionStorage.getItem("Band"),
      sessionStorage.getItem("User")
    );
    setWCS(result);
    setLoading(false);
    setFilteredResult(result);
  };

  const fetchColumnDefns = async () => {
    const result = GlobalColumnDefinations(tmpcolumnDefs);
    result[1].cellRenderer = HyperLink;
    setColumnDefs(result);
  };

  useEffect(() => {
    fetchWCS();
    fetchColumnDefns();
    fetchProject();
  }, [reload]);

  useImperativeHandle(ref, () => ({
    handleAdd: async () => {
      setAction("Add");
      if (
        headerObj?.WCS_Project_No !== "" &&
        headerObj?.WCS_Project_No !== undefined &&
        headerObj?.WCS_Project_No !== null
      ) {
        setShowForm(true);
      } else {
        setShowForm(false);
        showError(
          `Please select project number and click on show result before adding data .`
        );
      }
      setReload(true);
    },
  }));


  const resetForm = () => {
    document.filterForm.reset();
    setFilteredResult(WCS);
  };

  const handleClose = () => {
    setShow1(false);
  };

  const validateProject = (action) => {
    let isError = false;
    if (headerObj?.WCS_Project_No.trim() === "") {
      headerObj.WCS_Project_No = "";
      isError = true;
      error.WCS_Project_No = {
        status: true,
        message: "Project Number is required.",
      };
    }

    setError((prevState) => ({
      ...prevState,
      ...error,
    }));
    if (error.WCS_Project_No.status) {
      isError = true;
    }
    return isError;
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (
      headerObj?.WCS_Project_No !== "" &&
      headerObj?.WCS_Project_No !== undefined &&
      headerObj?.WCS_Project_No !== null
    ) {
      if (!validateProject(action)) {
        handleGlobalSearch(headerObj.WCS_Project_No);
        setSelectProject(headerObj.WCS_Project_No);
      }
    } else {
      showError(`Please select project number and click on show result .`);
    }
  };

  const handleGlobalSearch = (text) => {
    childRef.current.setSearch(text.toLowerCase());
  };

  const handleGlobalExport = () => {
    let filename = "WCSProjectList";
    setExcelData(filteredResult);
    handleExport1(filteredResult, filename, tmpcolumnDefs);
  };

  const [show1, setShow1] = useState(false);

  const fetchProject = async () => {
    let result = await getAllOnlyProject();
    setProjectDetails(result);
  };

  return (
    <Container fluid>
      <ConfirmAlertModal
        action={action}
        handleYes={handleView}
        show={show1}
        handleClose={handleClose}
      />

      <Row className="RowHeight">
        <Col md={2}>
          <Form.Group className="pro-input-select">
            <div>
              <SearchSelect
                id="WCS_Project_No"
                name="WCS_Project_No"
                className={error.WCS_Project_No.status ? "err-input" : ""}
                stylegreen={
                  error.WCS_Project_No.status ? errorstyle : normalstyle
                }
                data={ProjectDetails}
                valueField={"wld_ProjectNumber"}
                disabled={action === Action.ActionEdit}
                value={headerObj.WCS_Project_No}
                labelField={"wld_ProjectNumber"}
                placeholder=""
                onChange={(ProjectList) => {

                  setheaderObj((prev) => ({
                    ...prev,
                    WCS_Project_No: ProjectList.value,
                  }));
                  setSelectProject(ProjectList.value);
                  setError((prevState) => ({
                    ...prevState,
                    WCS_Project_No: {},
                  }));
                }}
                onInput={(e) => {
                  let error = isAlphanumericWithDash(e.target.value);
                  setError((prevState) => ({
                    ...prevState,
                    WCS_Project_No: error,
                  }));
                }}
              ></SearchSelect>
            </div>
            <Form.Label style={{ bottom: "32px" }}>Project Number</Form.Label>
            <div className="required-text-select">
              {error.WCS_Project_No.status && (
                <Form.Text className="text-danger">
                  {error.WCS_Project_No.message}
                </Form.Text>
              )}
            </div>
          </Form.Group>
        </Col>
        <Col md={4}>
          <Button className="showresult" onClick={handleSubmit} style={{ width: "109px", height: "40px" }}>
            <p style={{ fontSize: "14px", position: "relative", top: "8px" }}>Show Result</p >
          </Button>
        </Col>

        <Col md={6}>
          <div className="wcs-search-container">
            <GolbalSearch
              variant="wcs"
              searchplaceholdertext={"Search for Project No.,WCS Change No."}
              filterFunc={handleGlobalSearch}
            />
            <img
              className="allexport"
              src={ExportIcon}
              onMouseOver={(e) => (e.currentTarget.src = Export_blue)}
              onMouseOut={(e) => (e.currentTarget.src = ExportIcon)}
              alt="ExportIcon"
              onClick={handleGlobalExport}
            />
          </div>
        </Col>
      </Row>

      {loading && (
        <BarLoader height={5} width={195} className="gridloader" />
      )}

      <GridMaster
        rowDetails={filteredResult}
        colDetails={columnDefs}
        fieldNames={fieldName}
        headerNames={headerName}

        setExcelData={setExcelData}
        ref={childRef}
      />

      {showForm && (
        <AddEditWCS
          show={showForm}
          action={action}
          rowdata={rowData}
          onHide={() => setShowForm(false)}
          resetForm={resetForm}
          setReload={setReload}
          reload={reload}
          headerObj={headerObj}
          setheaderObj={setheaderObj}
          allRecs={WCS}
          backdrop="static"
          selectProject={selectProject}
        />
      )}
      {showUploadExcelForm && (
        <UploadWCSExcel
          show={showUploadExcelForm}
          action={action}
          rowdata={rowData}
          ProjNo={headerObj.WCS_Project_No}
          onHide={() => setshowUploadExcelForm(false)}
          resetForm={resetForm}
          setReload={setReload}
          reload={reload}
          headerObj={headerObj}
          setheaderObj={setheaderObj}
          allRecs={WCS}
          backdrop="static"
        />
      )}

      <Toaster />
      <Row style={{ padding: "5px 60px" }}>
        <div>
          {isDisabled ? (
            ""
          ) : (
            <Button
              size="sm"
              variant="outline-primary"
              className="me-2"
              disabled={isDisabled}
            >
              Prev
            </Button>
          )}

          {isDisabled ? (
            ""
          ) : (
            <Button size="sm" className="float-end  me-2">
              {"Send Approval"}
            </Button>
          )}

          {(() => {
            if (isDisabled) {
              return "";
            }
            if (originalaction !== Action.ActionAdd) {
              return "";
            }
            return (
              <Button
                size="sm"
                variant="outline-primary "
                className="float-end  me-2"
              >
                {"Send Approval"}
              </Button>
            );
          })()}
        </div>
      </Row>
    </Container>
  );
});

export default WCSDashboard;